/** Store markets + shop currency — used for Content tab goal currency options */

export const MARKETS_CURRENCIES_QUERY = {
  query: `query GetShopMarketCurrencies {
    markets(first: 50) {
      nodes {
        id
        name
        status
        primary
        currencySettings {
          baseCurrency {
            currencyCode
            currencyName
          }
        }
      }
    }
    shop {
      currencyCode
    }
  }`,
};

/** Fallback when read_markets is unavailable — shop presentment currencies */
export const SHOP_CURRENCIES_FALLBACK_QUERY = {
  query: `query GetShopCurrencies {
    shop {
      currencyCode
      enabledPresentmentCurrencies
    }
  }`,
};
